import { Typography } from 'fronton-react';
import React from 'react';
import { jc, jcm } from 'utils';
import {
  componentContainer,
  componentContainerThin,
  logoImageContainer,
  vendorLogoImg,
  titleContainer,
  titleContainerThin,
  titleContent,
} from './styles';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';

type BrandBadgeProps = {
  title: string;
  logoImg: string;
  variant?: 'general' | 'thin';
} & React.HTMLAttributes<HTMLElement>;

export const BrandBadge: React.FC<BrandBadgeProps> = ({
  title,
  logoImg,
  variant = 'general',
  className = '',
  ...htmlProps
}) => {
  const { t } = useTranslation();
  const caption = `Все товары марки ${title}`;

  return (
    <div
      className={jcm({
        [className]: true,
        [componentContainer]: true,
        [componentContainerThin]: variant === 'thin',
      })}
      {...htmlProps}
    >
      <div className={jc(logoImageContainer)}>
        <ImagePlaceholder
          className={jc(vendorLogoImg)}
          src={logoImg}
          loading="lazy"
          alt={title}
          fallbackWidth={130}
          fallbackHeight={60}
          fallbackAlt={t('ui.image.alt')}
        />
      </div>
      <div
        className={jcm({
          [titleContainer]: true,
          [titleContainerThin]: variant === 'thin',
        })}
      >
        <Typography className={titleContent} variant="s" size="body_short" color="text-secondary">
          {caption}
        </Typography>
      </div>
    </div>
  );
};
